(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modern-aplus"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('modern-aplus')) {
    const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

    class ModernAplus extends HTMLElement {
      connectedCallback() {
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.coarse = window.matchMedia('(pointer: coarse)').matches;
        this.mq = window.matchMedia('(max-width: 749px)'); // carousel on mobile, stacked list on desktop
        this.onMq = () => { this.measure(); this.fitHeight(); if (this.mq.matches) this.goTo(this.index, true); };
        if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);
        this.portals = [];
        this.index = 0;
        this.target = null;

        this.viewport = this.querySelector('[data-ma-viewport]');
        this.track = this.querySelector('[data-ma-track]');
        this.slides = this.qsa('[data-ma-slide]');
        this.rail = this.querySelector('[data-ma-rail]');
        this.thumbs = this.qsa('[data-ma-thumb]');
        this.curEl = this.querySelector('[data-ma-cur]');
        this.progress = this.querySelector('[data-ma-progress]');
        this.prevBtns = this.qsa('[data-ma-prev]');
        this.nextBtns = this.qsa('[data-ma-next]');
        this.lb = this.portal(this.querySelector('[data-ma-lb]'));

        try { if (sessionStorage.getItem('ma-zoomed')) this.classList.add('ma--zoomed-once'); } catch (e) {}

        this.initLoading();
        this.initReveal();
        this.initCarousel();
        this.initLightbox();
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.ro) this.ro.disconnect();
        if (this.mq && this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq);
        if (this.onKey) document.removeEventListener('keydown', this.onKey);
        if (this.lb && this.lb.classList.contains('is-open')) this.unlock();
        clearTimeout(this.targetTimer); clearTimeout(this.tapTimer); clearTimeout(this.hintTimer);
        (this.portals || []).forEach((el) => el.remove());
      }

      qsa(sel) { return Array.from(this.querySelectorAll(sel)); }
      pad2(n) { return n < 10 ? '0' + n : String(n); }
      behavior() { return this.reduce ? 'auto' : 'smooth'; }

      /* Move fixed-position UI to <body>, so theme transforms on ancestors can't break it */
      portal(el) {
        if (!el) return null;
        el.style.cssText = (this.closest('.ma-section') || this).style.cssText;
        document.body.appendChild(el);
        this.portals.push(el);
        return el;
      }

      /* ---------- Loading shimmer ---------- */
      initLoading() {
        this.qsa('.ma-slide__media img').forEach((img) => {
          if (img.complete && img.naturalWidth) return;
          const media = img.closest('.ma-slide__media');
          media.classList.add('is-loading');
          const done = () => { media.classList.remove('is-loading'); this.fitHeight(); };
          img.addEventListener('load', done, { once: true });
          img.addEventListener('error', done, { once: true });
        });
      }

      /* ---------- Entrance ---------- */
      initReveal() {
        if (this.reduce || !('IntersectionObserver' in window)) return;
        this.classList.add('ma--ready');
        void this.offsetHeight;
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting || e.boundingClientRect.top < 0) {
              e.target.classList.add('is-in');
              this.io.unobserve(e.target);
            }
          });
        }, { threshold: 0 }); // 0 so even very tall elements always reveal
        this.qsa('[data-ma-rise]').forEach((el) => this.io.observe(el));
      }

      /* ---------- Carousel ---------- */
      initCarousel() {
        if (!this.track || !this.slides.length) return;
        this.measure();

        let raf = 0;
        this.track.addEventListener('scroll', () => {
          if (raf) return;
          raf = requestAnimationFrame(() => { raf = 0; this.sync(); });
        }, { passive: true });

        this.prevBtns.forEach((b) => b.addEventListener('click', () => this.goTo(this.index - 1)));
        this.nextBtns.forEach((b) => b.addEventListener('click', () => this.goTo(this.index + 1)));
        this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.goTo(i)));

        this.track.addEventListener('keydown', (e) => {
          const map = { ArrowRight: this.index + 1, ArrowLeft: this.index - 1, Home: 0, End: this.slides.length - 1 };
          if (e.key in map) { e.preventDefault(); this.goTo(map[e.key]); }
        });

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => { this.measure(); this.fitHeight(); });
          this.ro.observe(this.track);
          this.slides.forEach((s) => this.ro.observe(s));
        }
        this.setActive(0);
      }

      measure() {
        if (!this.track) return;
        this.snapPad = parseFloat(getComputedStyle(this.track).scrollPaddingLeft) || 0;
      }

      sync() {
        const left = this.track.getBoundingClientRect().left + this.snapPad;
        let best = 0, bd = Infinity;
        this.slides.forEach((s, i) => {
          const d = Math.abs(s.getBoundingClientRect().left - left);
          if (d < bd) { bd = d; best = i; }
        });
        if (this.target !== null) {
          if (best !== this.target) return; // still travelling to a chosen slide
          this.target = null;
        }
        if (best !== this.index) this.setActive(best);
      }

      goTo(i, instant) {
        const n = this.slides.length;
        i = clamp(i, 0, n - 1);
        const s = this.slides[i];
        this.target = i;
        clearTimeout(this.targetTimer);
        this.targetTimer = setTimeout(() => { this.target = null; this.sync(); }, 900);
        this.track.scrollTo({ left: s.offsetLeft - this.snapPad, behavior: instant ? 'auto' : this.behavior() });
        this.setActive(i);
      }

      setActive(i) {
        this.index = i;
        const n = this.slides.length;
        this.slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
        this.thumbs.forEach((t, k) => {
          if (k === i) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
        if (this.curEl) this.curEl.textContent = this.pad2(i + 1);
        if (this.progress) this.progress.style.setProperty('--p', ((i + 1) / n).toFixed(3));
        this.prevBtns.forEach((b) => b.setAttribute('aria-disabled', i === 0 ? 'true' : 'false'));
        this.nextBtns.forEach((b) => b.setAttribute('aria-disabled', i === n - 1 ? 'true' : 'false'));
        this.fitHeight();
        this.revealThumb(i);
      }

      /* The frame takes the height of the current image: nothing cropped, no wasted space */
      fitHeight() {
        const s = this.slides && this.slides[this.index];
        if (!s || !this.viewport) return;
        if (!this.mq.matches) { this.viewport.style.height = ''; return; } // desktop: natural stacked height
        const h = s.offsetHeight;
        if (h) this.viewport.style.height = h + 'px';
      }

      revealThumb(i) {
        const t = this.thumbs[i];
        if (!t || !this.rail || !this.rail.offsetParent || this.rail.scrollWidth <= this.rail.clientWidth) return;
        const left = t.offsetLeft - (this.rail.clientWidth - t.offsetWidth) / 2;
        this.rail.scrollTo({ left: left, behavior: this.behavior() });
      }

      /* ---------- Full-screen viewer ---------- */
      initLightbox() {
        if (!this.lb) return;
        this.triggers = this.qsa('[data-ma-open]');
        this.stage = this.lb.querySelector('[data-ma-lb-stage]');
        this.lbImg = this.lb.querySelector('[data-ma-lb-img]');
        this.lbCount = this.lb.querySelector('[data-ma-lb-count]');
        this.zoomBtn = this.lb.querySelector('[data-ma-lb-zoom]');
        this.hint = this.lb.querySelector('[data-ma-lb-hint]');
        this.current = 0;
        this.z = { s: 1, x: 0, y: 0 };
        this.pts = new Map();
        this.g = null;

        // Mobile: tapping a peeking neighbour brings it forward. Otherwise the image opens in the viewer.
        this.triggers.forEach((t, i) => t.addEventListener('click', () => {
          if (this.mq.matches && i !== this.index) this.goTo(i);
          else this.open(i, t);
        }));

        const prev = this.lb.querySelector('[data-ma-lb-prev]');
        const next = this.lb.querySelector('[data-ma-lb-next]');
        if (prev) prev.addEventListener('click', () => this.go(-1));
        if (next) next.addEventListener('click', () => this.go(1));
        this.lb.querySelector('[data-ma-lb-close]').addEventListener('click', () => this.close());
        this.zoomBtn.addEventListener('click', () => {
          const c = this.center();
          this.zoomAt(c.x, c.y);
        });
        this.lbImg.addEventListener('load', () => this.lbImg.classList.add('is-loaded'));
        this.lbImg.addEventListener('dragstart', (e) => e.preventDefault());

        this.stage.addEventListener('pointerdown', (e) => this.onDown(e));
        this.stage.addEventListener('pointermove', (e) => this.onMove(e));
        this.stage.addEventListener('pointerup', (e) => this.onUp(e, false));
        this.stage.addEventListener('pointercancel', (e) => this.onUp(e, true));
        this.stage.addEventListener('wheel', (e) => this.onWheel(e), { passive: false });
        // iOS Safari: stop its own page pinch-zoom while the viewer is open
        this.lb.addEventListener('gesturestart', (e) => e.preventDefault());

        this.onKey = (e) => {
          if (!this.lb.classList.contains('is-open')) return;
          if (e.key === 'Escape') this.close();
          else if (e.key === 'ArrowRight') this.go(1);
          else if (e.key === 'ArrowLeft') this.go(-1);
          else if (e.key === '+' || e.key === '=') { const c = this.center(); if (this.z.s <= 1.01) this.zoomAt(c.x, c.y); }
          else if (e.key === '-') this.resetZoom(false);
          else if (e.key === 'Tab') this.trapFocus(e);
        };
        document.addEventListener('keydown', this.onKey);
      }

      /* -- zoom engine -- */
      center() {
        const r = this.stage.getBoundingClientRect();
        return {
          x: r.left + this.lbImg.offsetLeft + this.lbImg.offsetWidth / 2,
          y: r.top + this.lbImg.offsetTop + this.lbImg.offsetHeight / 2
        };
      }

      maxScale() {
        const w = this.lbImg.offsetWidth || 1;
        const natural = this.lbImg.naturalWidth || w;
        return clamp(natural / w * 1.5, 3, 8);
      }

      clampPan() {
        const z = this.z;
        const r = this.stage.getBoundingClientRect();
        const c = this.center();
        const w = this.lbImg.offsetWidth * z.s;
        const h = this.lbImg.offsetHeight * z.s;
        if (w <= r.width) z.x = 0;
        else z.x = clamp(z.x, r.right - c.x - w / 2, r.left - c.x + w / 2);
        if (h <= r.height) z.y = 0;
        else z.y = clamp(z.y, r.bottom - c.y - h / 2, r.top - c.y + h / 2);
      }

      apply() {
        const z = this.z;
        this.lbImg.style.transform = 'translate3d(' + z.x + 'px,' + z.y + 'px,0) scale(' + z.s + ')';
        const zoomed = z.s > 1.01;
        this.lb.classList.toggle('is-zoomed', zoomed);
        this.zoomBtn.setAttribute('aria-pressed', zoomed ? 'true' : 'false');
        this.zoomBtn.setAttribute('aria-label', zoomed ? 'Zoom out' : 'Zoom in');
      }

      anim(on) { this.lbImg.classList.toggle('is-anim', on && !this.reduce); }

      resetZoom(instant) {
        this.z = { s: 1, x: 0, y: 0 };
        this.anim(!instant);
        this.apply();
      }

      zoomAt(px, py) {
        if (this.z.s > 1.01) { this.resetZoom(false); return; }
        const S = Math.min(this.maxScale(), 2.75);
        const c = this.center();
        this.z = { s: S, x: (px - c.x) * (1 - S), y: (py - c.y) * (1 - S) };
        this.clampPan();
        this.anim(true);
        this.apply();
        this.dismissHint();
      }

      settle() {
        this.anim(true);
        if (this.z.s < 1.02) this.z = { s: 1, x: 0, y: 0 };
        else { this.z.s = Math.min(this.z.s, this.maxScale()); this.clampPan(); }
        this.apply();
        this.lb.style.setProperty('--fade', '1');
      }

      /* -- gestures: pinch, double-tap, pan, swipe to change, swipe down to close -- */
      onDown(e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        try { this.stage.setPointerCapture(e.pointerId); } catch (err) {}
        this.pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        this.anim(false);
        this.dismissHint();
        if (this.pts.size === 2) {
          const v = Array.from(this.pts.values());
          this.g = {
            mode: 'pinch',
            d: Math.hypot(v[0].x - v[1].x, v[0].y - v[1].y) || 1,
            m: { x: (v[0].x + v[1].x) / 2, y: (v[0].y + v[1].y) / 2 },
            s: this.z.s, x: this.z.x, y: this.z.y, moved: true
          };
          clearTimeout(this.tapTimer);
        } else if (this.pts.size === 1) {
          this.g = { mode: 'pending', sx: e.clientX, sy: e.clientY, x: this.z.x, y: this.z.y, moved: false, onImg: e.target === this.lbImg };
        }
      }

      onMove(e) {
        if (!this.pts.has(e.pointerId)) return;
        this.pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        const g = this.g;
        if (!g) return;

        if (g.mode === 'pinch') {
          if (this.pts.size < 2) return;
          const v = Array.from(this.pts.values());
          const d = Math.hypot(v[0].x - v[1].x, v[0].y - v[1].y);
          const m = { x: (v[0].x + v[1].x) / 2, y: (v[0].y + v[1].y) / 2 };
          const c = this.center();
          const s = clamp(g.s * d / g.d, .8, this.maxScale() * 1.15);
          const ux = (g.m.x - c.x - g.x) / g.s;
          const uy = (g.m.y - c.y - g.y) / g.s;
          this.z = { s: s, x: m.x - c.x - ux * s, y: m.y - c.y - uy * s };
          this.apply();
          return;
        }

        const dx = e.clientX - g.sx, dy = e.clientY - g.sy;
        if (!g.moved) {
          if (Math.hypot(dx, dy) < 8) return;
          g.moved = true;
          if (this.z.s > 1.01) g.mode = 'pan';
          else if (Math.abs(dx) > Math.abs(dy)) g.mode = this.triggers.length > 1 ? 'swipe' : 'none';
          else g.mode = dy > 0 ? 'dismiss' : 'none';
          this.lb.classList.toggle('is-dragging', g.mode === 'pan');
        }
        if (g.mode === 'pan') {
          this.z.x = g.x + dx; this.z.y = g.y + dy;
          this.clampPan();
          this.apply();
        } else if (g.mode === 'swipe') {
          this.z.x = dx * .9;
          this.apply();
        } else if (g.mode === 'dismiss') {
          this.z.y = Math.max(0, dy);
          this.z.x = dx * .3;
          this.apply();
          this.lb.style.setProperty('--fade', Math.max(.25, 1 - dy / 450).toFixed(3));
        }
      }

      onUp(e, cancelled) {
        if (!this.pts.has(e.pointerId)) return;
        this.pts.delete(e.pointerId);
        const g = this.g;
        if (!g) return;
        this.lb.classList.remove('is-dragging');

        if (g.mode === 'pinch') {
          if (this.pts.size === 1) {
            // one finger left: keep panning with it
            const p = Array.from(this.pts.values())[0];
            this.g = { mode: this.z.s > 1.01 ? 'pan' : 'none', sx: p.x, sy: p.y, x: this.z.x, y: this.z.y, moved: true };
            if (this.z.s <= 1.01) this.settle();
          } else if (this.pts.size === 0) {
            this.g = null;
            this.settle();
          }
          return;
        }
        if (this.pts.size) return;
        this.g = null;
        if (cancelled) { this.settle(); return; }

        const dx = e.clientX - g.sx, dy = e.clientY - g.sy;
        if (!g.moved) { this.tap(e, g); return; }
        if (g.mode === 'swipe' && Math.abs(dx) > Math.min(80, this.stage.clientWidth * .18)) { this.go(dx < 0 ? 1 : -1); return; }
        if (g.mode === 'dismiss' && dy > 110) { this.close(); return; }
        this.settle();
      }

      tap(e, g) {
        if (e.pointerType === 'mouse') {
          if (g.onImg) this.zoomAt(e.clientX, e.clientY);
          else if (this.z.s <= 1.01) this.close();
          else this.resetZoom(false);
          return;
        }
        const now = performance.now();
        const last = this.lastTap;
        if (last && now - last.t < 300 && Math.hypot(e.clientX - last.x, e.clientY - last.y) < 40) {
          clearTimeout(this.tapTimer);
          this.lastTap = null;
          this.zoomAt(e.clientX, e.clientY);
          return;
        }
        this.lastTap = { t: now, x: e.clientX, y: e.clientY };
        if (!g.onImg && this.z.s <= 1.01) {
          clearTimeout(this.tapTimer);
          this.tapTimer = setTimeout(() => this.close(), 300); // tap on the dark backdrop closes
        }
      }

      onWheel(e) {
        if (!this.lb.classList.contains('is-open')) return;
        e.preventDefault();
        const s0 = this.z.s;
        const s1 = clamp(s0 * Math.exp(-e.deltaY * (e.ctrlKey ? .01 : .0015)), 1, this.maxScale());
        if (s1 === s0) return;
        const c = this.center();
        this.z.x = e.clientX - c.x - (e.clientX - c.x - this.z.x) * (s1 / s0);
        this.z.y = e.clientY - c.y - (e.clientY - c.y - this.z.y) * (s1 / s0);
        this.z.s = s1;
        if (s1 <= 1.01) this.z = { s: 1, x: 0, y: 0 };
        this.clampPan();
        this.anim(false);
        this.apply();
        this.dismissHint();
      }

      /* -- hint shown the first time the viewer opens in a session -- */
      showHint() {
        if (!this.hint) return;
        let seen = false;
        try { seen = !!sessionStorage.getItem('ma-hint'); sessionStorage.setItem('ma-hint', '1'); } catch (e) {}
        if (seen) return;
        this.hint.textContent = this.coarse
          ? 'Pinch or double-tap to zoom · Swipe down to close'
          : 'Click or scroll to zoom · Drag to move';
        this.hint.classList.add('is-shown');
        clearTimeout(this.hintTimer);
        this.hintTimer = setTimeout(() => this.dismissHint(), 3200);
      }

      dismissHint() { if (this.hint) this.hint.classList.remove('is-shown'); }

      /* -- open / close / navigate -- */
      trapFocus(e) {
        const items = Array.from(this.lb.querySelectorAll('button')).filter((b) => b.offsetParent !== null);
        if (!items.length) return;
        const first = items[0], last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }

      show(i, dir) {
        const n = this.triggers.length;
        this.current = (i + n) % n;
        const t = this.triggers[this.current];
        this.resetZoom(true);
        this.lb.style.setProperty('--fade', '1');
        this.lbImg.classList.remove('is-loaded');
        this.lbImg.alt = t.dataset.alt || '';
        this.lbImg.src = t.dataset.full;
        if (this.lbImg.complete && this.lbImg.naturalWidth) this.lbImg.classList.add('is-loaded');
        if (dir && !this.reduce) {
          // small slide-in in the direction of travel
          this.z.x = dir * 60; this.apply();
          void this.lbImg.offsetWidth;
          this.anim(true); this.z.x = 0; this.apply();
        }
        if (this.lbCount) this.lbCount.textContent = (this.current + 1) + ' / ' + n;
        [-1, 1].forEach((d) => {
          const nb = this.triggers[(this.current + d + n) % n];
          if (nb && nb !== t) { const pre = new Image(); pre.src = nb.dataset.full; }
        });
      }

      go(step) { if (this.triggers.length > 1) this.show(this.current + step, step); }

      lock() {
        const sbw = window.innerWidth - document.documentElement.clientWidth;
        this.prevOverflow = document.body.style.overflow;
        this.prevHtmlOverflow = document.documentElement.style.overflow;
        this.prevPad = document.body.style.paddingRight;
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
      }

      unlock() {
        document.body.style.overflow = this.prevOverflow || '';
        document.documentElement.style.overflow = this.prevHtmlOverflow || '';
        document.body.style.paddingRight = this.prevPad || '';
      }

      open(i, trigger) {
        this.lastTrigger = trigger;
        this.show(i, 0);
        this.lb.inert = false;
        this.lb.setAttribute('aria-hidden', 'false');
        this.lb.classList.add('is-open');
        this.lock();
        this.lb.querySelector('[data-ma-lb-close]').focus({ preventScroll: true });
        this.showHint();
        this.classList.add('ma--zoomed-once');
        try { sessionStorage.setItem('ma-zoomed', '1'); } catch (e) {}
      }

      close() {
        clearTimeout(this.tapTimer);
        this.pts.clear();
        this.g = null;
        this.dismissHint();
        this.lb.classList.remove('is-open', 'is-dragging');
        this.lb.inert = true;
        this.lb.setAttribute('aria-hidden', 'true');
        this.unlock();
        this.resetZoom(true);
        this.lb.style.setProperty('--fade', '1');
        // keep the carousel on whatever image the shopper ended on
        if (this.mq.matches && this.current !== this.index) this.goTo(this.current, true);
        const back = this.triggers[this.current] || this.lastTrigger;
        if (back) back.focus({ preventScroll: true });
      }
    }
    customElements.define('modern-aplus', ModernAplus);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-faq-home"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__newFaqBound) return;
  window.__newFaqBound = true;

  function setState(item, open) {
    item.classList.toggle('active', open);
    var btn = item.querySelector('.faq-question');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  // one delegated listener: works for every FAQ section and after theme-editor reloads
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.faq-question') : null;
    if (!btn) return;

    var item = btn.closest('.faq-item');
    var root = item && item.closest('.new-faq-home');
    if (!root) return;

    var willOpen = !item.classList.contains('active');

    if (root.getAttribute('data-single') !== 'false') {
      root.querySelectorAll('.faq-item.active').forEach(function (other) {
        if (other !== item) setState(other, false);
      });
    }

    setState(item, willOpen);
  });

  function init(scope) {
    (scope || document).querySelectorAll('.new-faq-home').forEach(function (root) {
      if (root.getAttribute('data-ready')) return;
      root.setAttribute('data-ready', '1');
      root.classList.add('is-ready');

      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced || !('IntersectionObserver' in window)) return;

      root.classList.add('is-armed');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            root.classList.add('is-in');
            io.disconnect();
          }
        });
      }, { threshold: 0.12 });
      io.observe(root);
    });
  }

  init();
  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var SEL = '[data-pv-root]';
    var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var conn = navigator.connection || {};
    var saveData = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
    var canAuto = !mqReduce.matches && !saveData;

    function closest(el, sel) {
      return el && el.closest ? el.closest(sel) : null;
    }

    function toast(frame, msg) {
      var t = frame && frame.querySelector('.pv__toast');
      if (!t) return;
      t.textContent = msg;
      t.classList.add('is-on');
      clearTimeout(t._timer);
      t._timer = setTimeout(function () { t.classList.remove('is-on'); }, 1800);
    }

    function copyText(text, ok, fail) {
      function legacy() {
        var done = false;
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
        document.body.appendChild(ta);
        ta.select();
        try { ta.setSelectionRange(0, text.length); done = document.execCommand('copy'); } catch (err) {}
        document.body.removeChild(ta);
        if (done) ok(); else fail();
      }
      if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(ok, legacy);
      } else {
        legacy();
      }
    }

    function playTap(btn) {
      btn.classList.remove('is-tap');
      void btn.offsetWidth;
      btn.classList.add('is-tap');
      clearTimeout(btn._tapTimer);
      btn._tapTimer = setTimeout(function () { btn.classList.remove('is-tap'); }, 900);
    }

    function closeSheet(frame) {
      if (!frame || !frame.hasAttribute('data-sheet')) return;
      frame.removeAttribute('data-sheet');
      var t = frame._pvTrigger;
      frame._pvTrigger = null;
      if (t && t.focus) { try { t.focus({ preventScroll: true }); } catch (err) {} }
    }

    function openSheet(frame, name, trigger) {
      frame.setAttribute('data-sheet', name);
      frame._pvTrigger = trigger;
      var sheet = frame.querySelector('.pv__sheet--' + name);
      var x = sheet && sheet.querySelector('[data-pv-close]');
      if (x) setTimeout(function () { try { x.focus({ preventScroll: true }); } catch (err) {} }, 60);
    }

    function buildItem(frame) {
      var video = frame.querySelector('video');
      if (!video) return null;
      var bar = frame.querySelector('.pv__bar');
      var muteBtn = frame.querySelector('[data-pv-mute]');
      var toggles = [].slice.call(frame.querySelectorAll('[data-pv-toggle]'));
      var it = { frame: frame, video: video, inView: false, userPaused: false, userPlay: false, raf: 0 };

      function set(name, val) { frame.setAttribute('data-' + name, val); }

      function labelToggles() {
        var txt = video.paused ? 'Play video' : 'Pause video';
        toggles.forEach(function (b) { b.setAttribute('aria-label', txt); });
      }

      function paint() {
        if (bar && video.duration) {
          bar.style.transform = 'scaleX(' + Math.min(video.currentTime / video.duration, 1) + ')';
        }
      }
      function tick() {
        paint();
        if (!video.paused) it.raf = requestAnimationFrame(tick);
      }

      it.play = function () {
        var p = video.play();
        if (p && p.catch) {
          p.catch(function () {
            set('playing', 'false');
            set('loading', 'false');
            labelToggles();
          });
        }
      };

      function toggle() {
        if (video.paused) { it.userPaused = false; it.userPlay = true; it.play(); }
        else { it.userPaused = true; video.pause(); }
      }

      frame.addEventListener('click', function (e) {
        if (frame.hasAttribute('data-sheet')) return;
        if (closest(e.target, 'button, a, .pv__sheet, .pv__scrim, .pv__act')) return;
        toggle();
      });
      toggles.forEach(function (b) { b.addEventListener('click', toggle); });

      if (muteBtn) {
        muteBtn.addEventListener('click', function () { video.muted = !video.muted; });
      }

      video.addEventListener('play', function () {
        set('playing', 'true');
        set('loading', video.readyState < 3 ? 'true' : 'false');
        labelToggles();
        cancelAnimationFrame(it.raf);
        it.raf = requestAnimationFrame(tick);
      });
      video.addEventListener('playing', function () {
        set('ready', 'true');
        set('loading', 'false');
      });
      video.addEventListener('canplay', function () {
        if (!video.paused) set('loading', 'false');
      });
      video.addEventListener('waiting', function () {
        if (!video.paused) set('loading', 'true');
      });
      video.addEventListener('pause', function () {
        set('playing', 'false');
        set('loading', 'false');
        labelToggles();
        cancelAnimationFrame(it.raf);
        paint();
      });
      video.addEventListener('error', function () {
        set('playing', 'false');
        set('loading', 'false');
        labelToggles();
      });
      video.addEventListener('volumechange', function () {
        set('muted', video.muted ? 'true' : 'false');
        if (muteBtn) {
          muteBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
          muteBtn.setAttribute('title', video.muted ? 'Unmute' : 'Mute');
        }
      });
      video.addEventListener('loadedmetadata', paint);

      it.dispose = function () {
        cancelAnimationFrame(it.raf);
        if (!video.paused) video.pause();
      };
      return it;
    }

    function sync(it) {
      var visible = it.frame.getClientRects().length > 0;
      var want = it.inView && visible && !document.hidden && !it.userPaused && (canAuto || it.userPlay);
      if (want && it.video.paused) it.play();
      else if (!want && !it.video.paused) it.video.pause();
    }

    function setup(root) {
      if (root._pvReady) return;
      root._pvReady = true;
      root.classList.add('pv-js');

      var items = [].slice.call(root.querySelectorAll('[data-pv]')).map(buildItem).filter(Boolean);
      var observers = [];
      var mq = window.matchMedia('(max-width: 768px)');

      function syncAll() { items.forEach(sync); }
      function closeAll() { items.forEach(function (it) { closeSheet(it.frame); }); }

      function onClick(e) {
        var b = closest(e.target, '[data-pv-close]');
        var frame;
        if (b) {
          frame = closest(b, '[data-pv]');
          closeSheet(frame);
          return;
        }

        b = closest(e.target, '[data-pv-copy]');
        if (b) {
          frame = closest(b, '[data-pv]');
          copyText(b.getAttribute('data-pv-copy'), function () {
            var old = b._label || b.textContent;
            b._label = old;
            b.textContent = 'Copied \u2713';
            b.classList.add('is-done');
            toast(frame, 'Code copied');
            clearTimeout(b._t);
            b._t = setTimeout(function () {
              b.textContent = old;
              b.classList.remove('is-done');
            }, 1800);
          }, function () {
            toast(frame, 'Press and hold the code to copy');
          });
          return;
        }

        b = closest(e.target, '[data-pv-act]');
        if (!b) return;
        frame = closest(b, '[data-pv]');
        var act = b.getAttribute('data-pv-act');
        playTap(b);

        if (act === 'offer') {
          if (frame.getAttribute('data-sheet') === 'offer') {
            closeSheet(frame);
          } else {
            openSheet(frame, 'offer', b);
            frame.classList.add('offer-seen');
          }
        } else if (act === 'share') {
          var data = { title: document.title, text: 'Take a look: ' + document.title, url: location.href };
          if (navigator.share) {
            navigator.share(data).catch(function (err) {
              if (err && err.name === 'AbortError') return;
              copyText(location.href, function () { toast(frame, 'Link copied'); }, function () {});
            });
          } else {
            copyText(location.href, function () { toast(frame, 'Link copied'); }, function () {});
          }
        }
      }

      function onRootKey(e) {
        if (e.key !== 'Tab') return;
        var frame = closest(e.target, '[data-pv][data-sheet]');
        if (!frame) return;
        var sheet = frame.querySelector('.pv__sheet--' + frame.getAttribute('data-sheet'));
        if (!sheet) return;
        var f = sheet.querySelectorAll('button');
        if (!f.length) return;
        var first = f[0];
        var last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }

      function onDocKey(e) { if (e.key === 'Escape') closeAll(); }

      root.addEventListener('click', onClick);
      root.addEventListener('keydown', onRootKey);
      document.addEventListener('keydown', onDocKey);
      document.addEventListener('visibilitychange', syncAll);
      if (mq.addEventListener) mq.addEventListener('change', syncAll);
      else if (mq.addListener) mq.addListener(syncAll);

      if ('IntersectionObserver' in window) {
        var warm = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            var v = e.target.querySelector('video');
            if (v && v.preload === 'none' && canAuto) v.preload = 'metadata';
            warm.unobserve(e.target);
          });
        }, { rootMargin: '600px 0px' });

        var watch = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var it = items.filter(function (i) { return i.frame === e.target; })[0];
            if (!it) return;
            it.inView = e.isIntersecting;
            if (e.isIntersecting) it.frame.classList.add('is-live');
            sync(it);
          });
        }, { threshold: 0.4 });

        items.forEach(function (it) { warm.observe(it.frame); watch.observe(it.frame); });
        observers.push(warm, watch);
      } else {
        items.forEach(function (it) { it.frame.classList.add('is-live'); });
      }

      root._pvDestroy = function () {
        observers.forEach(function (o) { o.disconnect(); });
        root.removeEventListener('click', onClick);
        root.removeEventListener('keydown', onRootKey);
        document.removeEventListener('keydown', onDocKey);
        document.removeEventListener('visibilitychange', syncAll);
        if (mq.removeEventListener) mq.removeEventListener('change', syncAll);
        else if (mq.removeListener) mq.removeListener(syncAll);
        items.forEach(function (it) { it.dispose(); });
        root._pvReady = false;
      };
    }

    function initAll(scope) {
      [].forEach.call((scope || document).querySelectorAll(SEL), setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      [].forEach.call(e.target.querySelectorAll(SEL), function (r) { if (r._pvDestroy) r._pvDestroy(); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
